export function disableLogs() {
  console.log = () => {}
  console.info = () => {}
  console.error = () => {}
  console.warn = () => {}
}

process.env.NODE_ENV === 'production' ? disableLogs() : null
// disableLogs()
